<template lang="pug">
  #modal-review.modal.fade(tabindex='-1' aria-hidden='true')
    .modal-dialog.modal-dialog-centered
      .modal-content
        .position-absolute.end-0.close-button.pointer.mt-2.me-2(@click.stop="skipReview")
          i.fa-solid.fa-x.fa-2x
        .modal-header-cus
          img(src='/new/img/logo.png')
          h5 {{$tc('ui.review')}}
        .modal-body
          .modal-top-info
            h5.modal-title.text-center.review-header {{$tc('ui.review_title')}}
          form.form-wrap.text-center.text-black
            .category-wrapper(v-for="question in surveyQuestions" :id="question.id")
              label {{question.question}}
              .rating(data-vote="0")
                .star.pointer
                  span.full(data-value="0" @click="updateStar(question.id, 1)" :id="question.id+'_1'")
                  span.selected(:id="question.id+'_select_1'")
                .star.pointer
                  span.full(data-value="2" @click="updateStar(question.id, 2)" :id="question.id+'_2'")
                  span.selected(:id="question.id+'_select_2'")
                .star.pointer
                  span.full(data-value="3" @click="updateStar(question.id, 3)" :id="question.id+'_3'")
                  span.selected(:id="question.id+'_select_3'")
                .star.pointer
                  span.full(data-value="4" @click="updateStar(question.id, 4)" :id="question.id+'_4'")
                  span.selected(:id="question.id+'_select_4'")
                .star.pointer
                  span.full(data-value="5" @click="updateStar(question.id, 5)" :id="question.id+'_5'")
                  span.selected(:id="question.id+'_select_5'")
            .category-wrapper
              .review-small-text.mb-1.text-danger(v-if="!starComplete && showError") {{$t('ui.fill_stars')}}
            .review-wrapper
              textarea.review-input.w-100(name="message" rows="5" minlength="5" maxlength="100" :placeholder="$tc('ui.custom_description.comment_placeholder')" v-model.trim="$v.userComment.$model")
              ValidateResult.text-danger(:value="$v.userComment" :valueTwo="$v.userComment" :valueThree="$v.userComment" :name="$tc('ui.review', 2)")
            //- .refer-wrapper
              .review-header
                | {{$t('ui.custom_description.review_header')}}
                i.fas.fa-gift
              //- .refer-info
                div(v-html="$t('ui.custom_description.refer_info')")
                //- | Earn 
                //- strong 8x Free Spins &nbsp;
                //- | for every RM30 Referred Friend Deposit
              //- .review-text.mt-2 {{$t('ui.custom_description.review_text')}}
              //- .refer-input-group
                input.prefix#prefix(type="number" maxlength="3" v-model.trim="$v.recipientPrefixNo.$model" @input="focus($event, 'fullnumber')" @keypress="$helpers.onlyNumber")
                span -
                input.mobile-number#fullnumber(type="number" maxlength="8" v-model.trim="$v.recipientNo.$model" @input="maxLengthChecking" @keypress="$helpers.onlyNumber")             
              //- ValidateResult(:value="$v.recipientPrefixNo" :valueTwo="$v.recipientNo" :name="$t('ui.phone_number')")
        .modal-footer.s2
          .text-center
            button.btn-submit.text-capitalize(type='button' @click.stop="submitReview") {{ $t('ui.done') }}
            button.btn-submit.text-capitalize(type='button' @click.stop="skipReview") {{ $t('ui.skip') }}
          //- .text-center
            button.btn-submit(type='button' @click.stop="skipReview") {{ $t('ui.skip') }}
</template>
<script>
import config from "@/config"
import errorTags from "@/errorTags"
import { required, minLength, maxLength } from 'vuelidate/lib/validators'
import ValidateResult from "@/library/ValidateResult"
export default {
  components: {
    ValidateResult
  },
  data(){
    return{
      starClicked: false,
      surveyQuestions: [],
      jsonRating: [],
      starComplete: true,
      showError: false, 
      userComment: "",
      recipientNo: "",
      // recipientPrefixNo: "",
    }
  },
  computed:{
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    },
  },
  validations:{
    userComment:{
      required,
      minLength: minLength(5),
      maxLength: maxLength(100)
    },
    // recipientPrefixNo:{
    //   required,
    //   minLength:minLength(3),
    //   maxLength: maxLength(3)
    // },
    // recipientNo:{
    //   required,
    //   minLength: minLength(7),
    //   maxLength: maxLength(8)
    // }
  },
  mounted(){
    var vm = this
    $("#modal-review").on("shown.bs.modal", function(e) {
      vm.getQuestion();
    });
    $("#modal-review").on("hidden.bs.modal", function(e) {
      vm.reset();
    });
  },
  methods:{
    maxLengthChecking(){
      if(this.recipientNo.length > 8){
        this.recipientNo = this.recipientNo.slice(0, 8);
      } 
    },
    // focus(e, target){
    //   if(this.recipientPrefixNo && this.recipientPrefixNo.length === 3) $(`#${target}`).focus();
    // },
    updateStar(id, target){
      switch(target){
        case 1:
          $(`#${id}_select_${target}`).addClass('is-animated');
          $(`#${id}_select_${target}`).addClass('pulse');
          $(`#${id}_1`).addClass('animate');
          $(`#${id}_1`).addClass('star-colour');
          $(`#${id}_2`).removeClass('animate');
          $(`#${id}_2`).removeClass('star-colour');
          $(`#${id}_3`).removeClass('animate');
          $(`#${id}_3`).removeClass('star-colour');
          $(`#${id}_4`).removeClass('animate');
          $(`#${id}_4`).removeClass('star-colour');
          $(`#${id}_5`).removeClass('animate');
          $(`#${id}_5`).removeClass('star-colour');
          break;
        case 2:
          $(`#${id}_select_${target}`).addClass('is-animated');
          $(`#${id}_select_${target}`).addClass('pulse');
          $(`#${id}_1`).addClass('animate');
          $(`#${id}_1`).addClass('star-colour');
          $(`#${id}_2`).addClass('animate');
          $(`#${id}_2`).addClass('star-colour');
          $(`#${id}_3`).removeClass('animate');
          $(`#${id}_3`).removeClass('star-colour');
          $(`#${id}_4`).removeClass('animate');
          $(`#${id}_4`).removeClass('star-colour');
          $(`#${id}_5`).removeClass('animate');
          $(`#${id}_5`).removeClass('star-colour');
          break;
        case 3:
          $(`#${id}_select_${target}`).addClass('is-animated');
          $(`#${id}_select_${target}`).addClass('pulse');
          $(`#${id}_1`).addClass('animate');
          $(`#${id}_1`).addClass('star-colour');
          $(`#${id}_2`).addClass('animate');
          $(`#${id}_2`).addClass('star-colour');
          $(`#${id}_3`).addClass('animate');
          $(`#${id}_3`).addClass('star-colour');
          $(`#${id}_4`).removeClass('animate');
          $(`#${id}_4`).removeClass('star-colour');
          $(`#${id}_5`).removeClass('animate');
          $(`#${id}_5`).removeClass('star-colour');
          break;
        case 4:
          $(`#${id}_select_${target}`).addClass('is-animated');
          $(`#${id}_select_${target}`).addClass('pulse');
          $(`#${id}_1`).addClass('animate');
          $(`#${id}_1`).addClass('star-colour');
          $(`#${id}_2`).addClass('animate');
          $(`#${id}_2`).addClass('star-colour');
          $(`#${id}_3`).addClass('animate');
          $(`#${id}_3`).addClass('star-colour');
          $(`#${id}_4`).addClass('animate');
          $(`#${id}_4`).addClass('star-colour');
          $(`#${id}_5`).removeClass('animate');
          $(`#${id}_5`).removeClass('star-colour');
          break;
        case 5:
          $(`#${id}_select_${target}`).addClass('is-animated');
          $(`#${id}_select_${target}`).addClass('pulse');
          $(`#${id}_1`).addClass('animate');
          $(`#${id}_1`).addClass('star-colour');
          $(`#${id}_2`).addClass('animate');
          $(`#${id}_2`).addClass('star-colour');
          $(`#${id}_3`).addClass('animate');
          $(`#${id}_3`).addClass('star-colour');
          $(`#${id}_4`).addClass('animate');
          $(`#${id}_4`).addClass('star-colour');
          $(`#${id}_5`).addClass('animate');
          $(`#${id}_5`).addClass('star-colour');
          break;
        default:
          break;
      }
      
      var validCheck = this.jsonRating.some(e => e.a === id);
      if(validCheck){
        for(var i in this.jsonRating){
          if(this.jsonRating[i].a === id){
            this.jsonRating[i].b = target
          }
        }
      }else{
        this.jsonRating.push({
          a: id,
          b: target
        })
      }
      if(this.jsonRating.length !== this.surveyQuestions.length){
        this.starComplete = false;
      }else{
        this.starComplete = true;
        this.showError = false;
      }
    },
    getQuestion(){
      if (this.sessionToken) {
        let comp = "epicwin"
        this.$store
          .dispatch("user/getQuestion", { comp })
          .then(response => {
            if (response.success == true) {
              this.surveyQuestions = response.data;
            } else {
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
          });
      }
    },
    submitReview(){
      this.$v.$touch();
      if(this.jsonRating.length !== this.surveyQuestions.length){
        this.starComplete = false;
        this.showError = true;
        return;
      }else{
        this.starComplete = true;
        this.showError = false;
      }
      if(!this.$v.$invalid){
        if (this.sessionToken) {
          let account_id = this.accountID
          let auth_token = this.sessionToken
          let json_rating = this.jsonRating
          let comment = this.userComment
          let recipient_no = null
          // let recipient_no = ""+this.recipientPrefixNo+this.recipientNo
          this.$store
            .dispatch("user/submitReview", { account_id, auth_token, json_rating, comment, recipient_no })
            .then(response => {
              if (response.success == true) {
                this.surveyQuestions = response.data;
                $('#modal-review').modal('hide')
                $('#modal-thankyou').modal('show')
              } else {
                if((typeof response.status) != 'object'){
                  this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
                }
              }
            })
            .catch(response => {
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            });
        }
      }
      
    },
    skipReview(){
      if (this.sessionToken) {
        let account_id = this.accountID
        let auth_token = this.sessionToken
        for (var x = 0; x < this.surveyQuestions.length; x++){
          this.jsonRating.push({
            "a": this.surveyQuestions[x].id,
            "b": 5
          })
        }
        let json_rating = this.jsonRating
        let comment = "EpicWin is the best!"
        let recipient_no = null
        // let recipient_no = ""+this.recipientPrefixNo+this.recipientNo
        this.$store
          .dispatch("user/submitReview", { account_id, auth_token, json_rating, comment, recipient_no })
          .then(response => {
            if (response.success == true) {
              // this.surveyQuestions = response.data;
              $('#modal-review').modal("hide")
            } else {
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
              $('#modal-review').modal("hide")
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
            $('#modal-review').modal("hide")
          });
      }else{
        $('#modal-review').modal("hide")
      }
    },
    reset(){
      this.jsonRating = [];
      this.userComment = "";
      // this.recipientPrefixNo = "";
      this.recipientNo = "";
      this.$v.$reset()
    }
  }
}
</script>